import {
    isSameOrderItem,
    isUseSamePriceList,
} from 'components/Sell/utils/common'
import {
    MenuViewModel,
    OrderItemViewModel,
    PriceListData,
} from 'store/models/sellModels'

interface AddItemCountingResult {
    newOrderItems: OrderItemViewModel[]
    newAddedItem: OrderItemViewModel
}

export function mergeCartItems(
    orderItems: OrderItemViewModel[],
    newItem: OrderItemViewModel,
    preventEditLines: string[] = [],
    menus: MenuViewModel[],
    priceListData: PriceListData,
): AddItemCountingResult {
    const exProd = orderItems.find(
        (i) =>
            !preventEditLines.includes(i.id) &&
            isSameOrderItem(i, newItem) &&
            isUseSamePriceList(menus, priceListData, i, newItem),
    )
    if (exProd) {
        exProd.amount += newItem.amount
        exProd.isSaved = false
        return {
            newOrderItems: orderItems,
            newAddedItem: exProd,
        }
    } else {
        return {
            newOrderItems: [...orderItems, newItem],
            newAddedItem: newItem,
        }
    }
}
